/**
 * The words of the phone app's own calling (piece 35; decision 12002): the Call in App choice, the call screen and
 * its three acts, spread into the one string lookup.
 */
export const PHONE_CALL_STRINGS = {
  'calls.app.choice': 'Call in App',
  'calls.app.choiceDetail': 'The contact sees the office number, and you talk here in the app.',
  'calls.app.title': 'Call',
  'calls.app.name': 'Name',
  'calls.app.number': 'Number',
  'calls.app.length': 'Length',
  'calls.app.connecting': 'Connecting…',
  'calls.app.mute': 'Mute',
  'calls.app.unmute': 'Unmute',
  'calls.app.speaker': 'Speaker',
  'calls.app.earpiece': 'Earpiece',
  'calls.app.end': 'End',
  'calls.app.ended': 'The call has ended. It shows in Recents within a minute.',
  'calls.app.failed': 'The call could not be placed.',
  'calls.app.unknownCaller': 'Unknown caller',
} as const;
